module.exports = __webpack_public_path__ + "static/img/rightUpOne.714e288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/rightUpOne.png
// module id = HpSl
// module chunks = 0